// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaMessageAlbum__album-b987b1 {
  border-radius: 16px;
  overflow: hidden;
  flex: 1 0 auto;
  margin: 8px 0;
  user-select: none;
}

.MediaMessageAlbum__row-a768fe {
  margin-bottom: 2px;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  max-width: 100%;
  &:last-child {
    margin-bottom: 0;
  }
}

.MediaMessageAlbum__item-fe01e2 {
  margin-inline-end: 2px;
  position: relative;
  &:last-child {
    margin-inline-end: 0;
  }
}

.MediaMessageAlbum__img-e3dae0 {
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.MediaMessageAlbum__duration-c18d61 {
  position: absolute;
  bottom: 8px;
  inset-inline-start: 8px;
  border-radius: 12px;
  background-color: var(--addition-40_60);
  padding: 2px 8px;
  color: var(--addition-50);
}

.MediaMessageAlbum__time-c98be7 {
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
}

.MediaMessageAlbum__play-icon-b92abd {
  fill: currentColor;
  vertical-align: middle;
}

.MediaMessageAlbum__item-fe01e2:hover .MediaMessageAlbum__delete-ba5f57 {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MediaMessagePopup/MediaMessageAlbum/MediaMessageAlbum.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;EACA;IACE,gBAAA;EACF;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA;IACE,oBAAA;EACF;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,2BAAA;EACA,6CAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":[".album {\n  border-radius: 16px;\n  overflow: hidden;\n  flex: 1 0 auto;\n  margin: 8px 0;\n  user-select: none;\n}\n\n.row {\n  margin-bottom: 2px;\n  display: flex;\n  justify-content: stretch;\n  align-items: stretch;\n  max-width: 100%;\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.item {\n  margin-inline-end: 2px;\n  position: relative;\n  &:last-child {\n    margin-inline-end: 0;\n  }\n}\n\n.img {\n  position: absolute;\n  inset-inline-start: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.duration {\n  position: absolute;\n  bottom: 8px;\n  inset-inline-start: 8px;\n  border-radius: 12px;\n  background-color: var(--addition-40_60);\n  padding: 2px 8px;\n  color: var(--addition-50);\n}\n\n.time {\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n}\n\n.play-icon {\n  fill: currentColor;\n  vertical-align: middle;\n}\n\n.item:hover .delete {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"album": `MediaMessageAlbum__album-b987b1`,
	"row": `MediaMessageAlbum__row-a768fe`,
	"item": `MediaMessageAlbum__item-fe01e2`,
	"img": `MediaMessageAlbum__img-e3dae0`,
	"duration": `MediaMessageAlbum__duration-c18d61`,
	"time": `MediaMessageAlbum__time-c98be7`,
	"play-icon": `MediaMessageAlbum__play-icon-b92abd`,
	"playIcon": `MediaMessageAlbum__play-icon-b92abd`,
	"delete": `MediaMessageAlbum__delete-ba5f57`
};
module.exports = ___CSS_LOADER_EXPORT___;
